import React, { useState, useEffect } from 'react'
import SBNav from '../../shared/components/SideBarNav/SBNav'
import './aboutcreator.scss'
import Footer from '../../components/Footer/Footer'

const AboutCreator = () => {

    useEffect(() => {
        document.title = 'About the Creator'
    }, [])

    const [nav, openNav] = useState(false);


    useEffect(() => {
        if (!nav) {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            return;
        }

        const scrollY = window.scrollY;

        document.documentElement.classList.add("nav-blur");

        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";

        return () => {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            window.scrollTo(0, scrollY);
        };
    }, [nav]);


    return (
        <div id='about-creator-page'>

            <div className='nav-wrapper'>
                <div className='nav-2'>

                    <div className='nav-logo-container'>
                        <img src='images/flashroom-logo-light.png' height="44px" />
                        <h1>Flash<span>Room</span></h1>
                    </div>

                    <div className='hamburger-menu-2' onClick={() => openNav(true)}>
                        <div />
                        <div />
                        <div />
                    </div>

                </div>
            </div>


            <div className={`nav-cont ${nav ? 'nav-open' : 'nav-closed'}`}>

                <div className='standard-xi-cont'

                    onClick={() => openNav(false)}
                >

                    <svg className="x-icon-sbn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>

                </div>

                <SBNav />

            </div>


            <div className="about-creator-content">
                <div className="creator-panel">
                    <div className="about-creator-top">
                        <div className="headshot-cont-abt">
                            <img src="images/headshot-small.jpg" alt="Dawson Bolen" />
                        </div>

                        <div className="creator-meta">
                            <h2>Dawson Bolen</h2>
                            <h3>Creator of FlashRoom</h3>

                            <div className="ab-creator-links">
                                <a href="https://www.dawsonbolen.com" target="_blank" rel="noreferrer">Portfolio</a>
                                <a href="https://www.linkedin.com/in/dawsonbolen" target="_blank" rel="noreferrer">LinkedIn</a>
                            </div>
                        </div>
                    </div>

                    <div className="creator-body">
                        <p>
                            I’m Dawson Bolen, a full-stack web developer and educator with a background in both design and software engineering. Over the past several years, I’ve built modern web applications using technologies like React, Node.js, MongoDB, and AWS, while also teaching students how to code through hands-on projects in real classroom environments. FlashRoom was created from that intersection of building and teaching, I wanted a platform that makes it effortless to share code, collaborate in real time, and distribute full project files the way students and developers actually need. What started as a personal project quickly became a solution to a problem I kept seeing in education: transferring starter code and resources shouldn’t be clunky or limited to plain text. FlashRoom is my attempt to make coding more accessible, organized, and collaborative for both learners and creators.
                        </p>
                    </div>
                </div>
            </div>

            <Footer />


        </div>
    )
}

export default AboutCreator
